<template>
<div>
  
    
    <div class="bg-white">
      <div class="container">
        <div class="row" style="padding:25px;">
          <h2 class="text-center" style="padding:25px;font-weight:bold;">ការ Login របស់អ្នកបរាជ័យ</h2>
          <!--  eslint-disable no-use-before-define  -->
          <p class="pf text-center">សូមចុះ login ដើម្បីធ្វើការ login ម្ដងទៀត។ សូមអគុណ!</p>
          
          <!--  eslint-enable no-use-before-define  -->
        </div>
        <div class="text-center">
          <button 
                @click="clickRegister"
                class="btn btn-primary"
            >Goto Login
          </button>
        </div>
      </div>
    </div>
    

</div>

</template>

<script>
export default {
  methods: {
    changeLanguage() {
      console.log(this.$i18n.locale);
      this.$i18n.locale = this.$i18n.locale == "en" ? "kh" : "en";
    },
    clickRegister() {
      this.$router.push({ name: "SystemLogin" });
      //
    },
    handleScroll(){
      if(this.$route.name == 'Home'){
        if(window.scrollY>=120){
          if(!this.$store.getters.getTempalte.headerScroll){
            this.$store.commit('changeTemplate',{
              headerScroll: 'navbar-transparent-scroll'
            });
          }
        }else{
          if(this.$store.getters.getTempalte.headerScroll){
              this.$store.commit('changeTemplate',{
                headerScroll: ''
              });
          }
        }
      }
    }
  },
  created () {
    //window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* navbar-transparent */
.bcover{
  display: block;
  position: absolute;
  background: #333;
  height: 110vh;
  border: 1px;
  width: 100%;
  opacity: 0.7;
  z-index: 1;
}
.top {
  color: #fff;
  /* width: 70%; */
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1000;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 70px;
}

.block{
  color: #fff;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bgcover {
  background: url("~@/assets/images/bg.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
  top: 0;
  left: 0;
}

.pf {
  font-size: 18px;
  text-align: justify;
  letter-spacing: -1px;
}

.bg-gray{
  background-color: #f1f1f1;
}

.bg-gray .container{
  background-color: #f1f1f1;
}

@media (max-width: 613px) {
  h3,
  h4,
  button {
    font-size: 14px;
  }
  .top {
    width: 100%;
    padding: 40px;
  }
}
</style>
